import React from "react";
import { Container } from "react-bootstrap";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import "../../App.css";

const AcceptableUsePolicy: React.FC = () => {
  return (
    <>
      <Header />
      <Container className="py-5 mt-4" style={{ maxWidth: 820 }}>
        <h1 className="fw-bold mb-1">Acceptable Use Policy</h1>
        <p className="text-secondary small mb-1">Last updated: August 2026</p>
        <p className="text-secondary small mb-5" style={{ lineHeight: 1.7 }}>
          ARM Financial Services Pty Ltd ("ARMF", "we", "us", or "our") · ABN 35 659 595 570 · ACN 659 595 570
          <br />
          Registered with AUSTRAC to provide remittance services in Australia (AAN 100812026, Registered Entity No. 75630)
        </p>

        <Section title="1. Purpose">
          This Acceptable Use Policy sets out how you may and may not use ARMF's services. It
          supplements Section 5 of our <a href="/terms-of-service">Terms of Service</a>.
        </Section>

        <Section title="2. Prohibited Uses">
          You must not use ARMF's services to:
          <ul className="mt-2">
            <li>Engage in or facilitate money laundering or terrorism financing</li>
            <li>Structure transactions to avoid AML/CTF reporting thresholds</li>
            <li>Evade Australian or international sanctions, or transact with a sanctioned individual, entity, or jurisdiction</li>
            <li>Commit or facilitate fraud, identity theft, or provide false or misleading information during onboarding</li>
            <li>Send or receive funds connected to illicit drugs, unlicensed weapons, or other unlawful goods or services</li>
            <li>Transact on behalf of an undisclosed third party</li>
            <li>Provide unlicensed money transmission or remittance services to others through your ARMF account</li>
            <li>Interfere with, disrupt, or attempt unauthorised access to our platform or systems</li>
          </ul>
        </Section>

        <Section title="3. Consequences of Breach">
          If we reasonably suspect your account is being used for a prohibited purpose, we may
          suspend or terminate your access immediately and without notice, and — where required
          by the AML/CTF Act 2006 (Cth) — report the activity to AUSTRAC or other relevant
          authorities.
        </Section>

        <Section title="4. Reporting Concerns">
          If you become aware of activity that may breach this policy, please contact us at{" "}
          <a href="mailto:support@armf.com">support@armf.com</a>.
        </Section>
      </Container>
      <Footer full={true} />
    </>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="mb-4">
    <h5 className="fw-semibold mb-2">{title}</h5>
    <div className="text-secondary" style={{ lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default AcceptableUsePolicy;
